import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { api, fileUrl } from "../lib/api";
import { useSeo, Icon } from "../components/common";
import { CTABand } from "../components/blocks";

export default function BlogPost() {
  const { slug } = useParams();
  const { t } = useLang();
  const [post, setPost] = useState(null);
  const [nf, setNf] = useState(false);
  useEffect(() => {
    api.get(`/content/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNf(true));
  }, [slug]);
  useSeo(post ? `${post.title} | Sparko Blog` : "Blog | Sparko", post?.excerpt);

  if (nf) return <div className="pt-40 text-center min-h-[60vh]"><h1 className="font-display text-3xl text-navy">Post not found</h1><Link to="/blog" className="mt-6 inline-block text-blue">Back to blog</Link></div>;
  if (!post) return <div className="min-h-[60vh] grid place-items-center"><Icon name="Loader2" size={32} className="animate-spin text-blue" /></div>;

  return (
    <article>
      <div className="relative h-[52vh] min-h-[380px] overflow-hidden bg-navy">
        <img src={fileUrl(post.image)} alt={post.title} className="h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy to-transparent" />
        <div className="absolute inset-x-0 bottom-0 mx-auto max-w-3xl px-5 pb-12">
          <span className="rounded-full bg-blue px-3 py-1 text-xs font-semibold text-white">{post.category}</span>
          <h1 className="mt-4 font-display text-3xl md:text-5xl text-white leading-[1.08]">{post.title}</h1>
          <p className="mt-3 text-white/60">{post.date} · {post.author}</p>
        </div>
      </div>
      <div className="mx-auto max-w-3xl px-5 md:px-8 py-16">
        <p className="text-xl text-navy font-display leading-snug">{post.excerpt}</p>
        <div className="mt-6 text-lg text-slate-600 leading-relaxed whitespace-pre-line">{post.content}</div>
        <Link to="/blog" className="mt-10 inline-flex items-center gap-2 text-blue font-semibold"><Icon name="ArrowLeft" size={17} className="rtl:rotate-180" /> All articles</Link>
      </div>
      <CTABand />
    </article>
  );
}
